export enum ScreenResolution {
  RES_720P = 'RES_720P',
  RES_1080P = 'RES_1080P',
  RES_4K = 'RES_4K',
}
